module.exports = __webpack_public_path__ + "img/bg-rank2.2e61008f.png";